import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-study-abroad',
  templateUrl: './study-abroad.component.html',
  styleUrls: ['./study-abroad.component.scss']
})
export class StudyAbroadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
